'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var AdvancedHepGridValidationService = function AdvancedHepGridValidationService(advancedHepGridService, advancedHepPayloadService, gridColumnValidationService, configurationService, AdvancedHepGridConstants, featureToggleService, advancedHepCommonValidationService, advancedHepModalGridValidationService) {
  var FARE_TYPES = {
    1: 'OW',
    2: 'RT',
    3: 'OWNC'
  };
  function isCustomValidationType(selected, gridPanel) {
    return (selected !== undefined ? isCustomHepType(selected.type) : false) || isCustomGridType(gridPanel);
  }
  function isCustomHepType(type) {
    return _.includes(AdvancedHepGridConstants.CUSTOM_VALIDATION_TYPES, type);
  }
  function isCustomGridType(gridPanel) {
    return gridPanel !== undefined ? _.includes(AdvancedHepGridConstants.CUSTOM_GRID_IDS, gridPanel.gridId) : false;
  }
  function findColumn(field, columns) {
    var resultColumn = {};
    _.forEach(columns, function (column) {
      if (_.isUndefined(column.field)) {
        _.forEach(column.columns, function (groupedColumn) {
          if (groupedColumn.field === field) {
            resultColumn = groupedColumn;
          }
        });
      } else {
        if (column.field === field) {
          resultColumn = column;
        }
      }
    });
    return resultColumn;
  }

  /**
   * When column is percentage type and cellendedit is invoked grid first invoke validation method and after that
   * changes the value (by dividing it by 100). That causes problem because same validation function is invoked on
   * cellendedit and clicking OK button on modal window. That means that same function was handling 13 vs 9 and 0.13 vs 9 for example
   * @param ruleName
   * @returns {*}
   */
  function changeValidationFunctionIfIsPercentage(ruleName) {
    return ruleName.includes('ForPercentage') ? ruleName.replace('ForPercentage', '') : ruleName;
  }
  function areColumnsValidationsFulfilled(editedRows, allRows, columns, customType) {
    var valid = true;
    advancedHepPayloadService.clearAllNestedRows(editedRows);
    _.forEach(editedRows, function (row) {
      if (!valid) {
        return;
      }
      var rowWithAssignedAllColumns = assignRowValueToAllColumns(row, columns);
      _.forOwn(rowWithAssignedAllColumns, function (fieldValue, field) {
        if (!valid) {
          return;
        }
        var fieldColumn = findColumn(field, columns);
        var validations = fieldColumn ? fieldColumn.validations : null;
        var cellTitle = fieldColumn ? fieldColumn.title : 'field: ' + field;
        if (!_.isEmpty(validations)) {
          var cell = {
            row: _.findIndex(allRows, row),
            column: field
          };
          _.forEach(validations, function (validation) {
            var params = [cell, fieldValue, row, allRows].concat(validation.params);
            var ruleValidator = gridColumnValidationService[changeValidationFunctionIfIsPercentage(validation.rule)];
            if (ruleValidator && !ruleValidator.apply(null, params)) {
              if (isCustomValidationType(customType)) {
                toastr.error(cellTitle + ' - ' + validation.message);
              }
              valid = false;
            }
          });
        }
      });
    });
    return valid;
  }
  function assignRowValueToAllColumns(row, columns) {
    var rowWithAssignedAllColumns = {};
    _.chain(columns).map(function (column) {
      return _.isUndefined(column.field) ? _.map(column.columns, 'field') : column.field;
    }).flatten().forEach(function (field) {
      rowWithAssignedAllColumns[field] = row[field];
    }).value();
    return rowWithAssignedAllColumns;
  }
  function isKeyUniq(editedRows, gridData, type, configType) {
    if (type === 'FlightExclusion') {
      return true;
    }
    if (type === 'FOTacticalUserOverrides') {
      return checkForInvalidUserOverrideRows(gridData);
    }
    var attributes = advancedHepGridService.getAttributesForDuplicateValidation(type, configType);
    for (var i = 0; i < editedRows.length; i++) {
      if (advancedHepCommonValidationService.isDuplicate(editedRows[i], gridData, attributes, type)) {
        if (isCustomHepType(type)) {
          toastr.error('Duplicate rows identified.');
        }
        return false;
      }
      if (type == 'FP_MetroMarket') {
        if (isMetroMarketDuplicatedInNeighborList(type, editedRows[i], attributes)) {
          toastr.error('A metro market can not be duplicated in it\'s neighboring market list.');
          return false;
        }
      }
      if (type == 'FOMarketList') {
        if (isMarketListDuplicate(editedRows[i], gridData, attributes, type)) {
          toastr.error('Duplicate/Overlapping rows Identified');
          return false;
        }
        if (isMarketListPropsValid(editedRows[i], gridData, attributes, type)) {
          toastr.error('Invalid Host Property Found');
          return false;
        }
        if (isGenerateNewCancelValid(editedRows[i], gridData, attributes, type)) {
          toastr.error('Invalid Generate New/Cancel Property Found');
          return false;
        }
      }
      if (type == 'FP_MarketConfig') {
        if (allBenchmarkCarriersAreEmpty(type, editedRows[i], attributes)) {
          toastr.error('At least one benchmark carrier must be defined.');
          return false;
        }
      }
      if (type === 'FORbdAssignment') {
        if (isRbdAssignmentsHavingSameRbdMethod(editedRows[i], gridData, attributes)) {
          toastr.error('Same attributes cannot have different rbd method/ladder method');
          return false;
        }
      }
    }
    return true;
  }
  function isRbdAssignmentsHavingSameRbdMethod(newEntry, allRows, attributes) {
    var allKeyValues = _.pick(newEntry, attributes);
    var rowsIdentical = _.chain(allRows).filter(allKeyValues).value();
    rowsIdentical = _.reject(rowsIdentical, newEntry);
    var isDifferentRbdMethod = false;
    _.forEach(rowsIdentical, function (row) {
      if (!isSameFieldValue(newEntry, row, 'rbdMethod') || !isSameFieldValue(newEntry, row, 'ladderMethod')) {
        isDifferentRbdMethod = true;
      }
    });
    return isDifferentRbdMethod;
  }
  function isMarketListDuplicate(newEntry, allRows, attributes, type) {
    var allKeyValues = _.pick(newEntry, ['hostCarrier', 'originAirport', 'destinationAirport', 'foCabin', 'marketListCategory']);
    var isMarketDuplicate = false;
    var rowsIdentical = _.chain(allRows).filter(allKeyValues).value();
    rowsIdentical = _.reject(rowsIdentical, newEntry);
    _.forEach(rowsIdentical, function (row) {
      if (hasIntersectingCommaSeparatedProperty(newEntry, row, 'benchmarkCarrier') && (hasIntersectingCommaSeparatedProperty(newEntry, row, 'hostFareTypeIndicator') || hasIntersectingCommaSeparatedProperty(newEntry, row, 'fareSource') && row['fareSource'] !== newEntry['fareSource'])) {
        isMarketDuplicate = true;
      }
    });
    return isMarketDuplicate;
  }
  function isMarketListPropsValid(newEntry, allRows, attributes, type) {
    var allKeyValues = _.pick(newEntry, ['originAirport', 'destinationAirport', 'foCabin', 'category']);
    var isMarketDuplicate = false;
    var rowsIdentical = _.chain(allRows).filter(allKeyValues).value();
    rowsIdentical = _.reject(rowsIdentical, newEntry);
    _.forEach(rowsIdentical, function (row) {
      if (isDifferentHostProperty(newEntry, row, 'marketTier', 'Market Tier')) {
        isMarketDuplicate = true;
      }
    });
    return isMarketDuplicate;
  }
  function isDifferentHostProperty(eachRow, row, field, fieldName) {
    if (_.isNil(eachRow[field]) && _.isNil(row[field]) || !_.isNil(eachRow[field]) && _.isEmpty(eachRow[field].toString()) && _.isNil(row[field]) || !_.isNil(row[field]) && _.isEmpty(row[field].toString()) && _.isNil(eachRow[field])) {
      return false;
    }
    if (!_.isNil(eachRow[field]) && !_.isNil(row[field]) && eachRow[field].valueOf().toString() === row[field].valueOf().toString()) {
      return false;
    }
    toastr.error(fieldName + ' should be same for same Market-Cabin-Category');
    return true;
  }
  function isGenerateNewCancelValid(newEntry, allRows, attributes, type) {
    var allKeyValues = _.pick(newEntry, ['hostCarrier', 'originAirport', 'destinationAirport', 'foCabin', 'marketListCategory']);
    var isGenerateNewCancelDuplicate = false;
    var rowsIdentical = _.chain(allRows).filter(allKeyValues).value();
    rowsIdentical = _.reject(rowsIdentical, newEntry);
    _.forEach(rowsIdentical, function (row) {
      if (isDifferentGenerateNewCancelProperty(newEntry, row, 'generateNewCancel', 'Generate New/Cancel')) {
        isGenerateNewCancelDuplicate = true;
      }
    });
    return isGenerateNewCancelDuplicate;
  }
  function isDifferentGenerateNewCancelProperty(eachRow, row, field, fieldName) {
    if (_.isNil(eachRow[field]) && _.isNil(row[field]) || !_.isNil(eachRow[field]) && _.isEmpty(eachRow[field].toString()) && _.isNil(row[field]) || !_.isNil(row[field]) && _.isEmpty(row[field].toString()) && _.isNil(eachRow[field])) {
      return false;
    }
    if (!_.isNil(eachRow[field]) && !_.isNil(row[field]) && eachRow[field] === row[field]) {
      return false;
    }
    toastr.error(fieldName + ' should be same for same hostCarrier-Market-Cabin-Category');
    return true;
  }
  function areCommaSeparatedValuesEmpty(newEntry, row, field) {
    if ((_.isUndefined(newEntry[field]) || _.isNull(newEntry[field]) || _.isEmpty(newEntry[field])) && (_.isUndefined(row[field]) || _.isNull(row[field]) || _.isEmpty(row[field]))) {
      return true;
    }
    return false;
  }
  function hasIntersectingCommaSeparatedProperty(newEntry, row, field) {
    if (newEntry[field] && row[field] && _.intersection(newEntry[field].split(','), row[field].split(',')).length > 0) {
      return true;
    }
    return false;
  }
  function isMetroMarketDuplicatedInNeighborList(type, row, attributes) {
    var fields = advancedHepCommonValidationService.getKeyValues(type, row, attributes);
    var neighbors = row['metroMarketParams-neighbors'];
    return _.some(neighbors, {
      neighborMarketOrigin: fields.marketOrigin,
      neighborMarketDestination: fields.marketDestination
    });
  }
  function allBenchmarkCarriersAreEmpty(type, row, attributes) {
    var cabinCodes = _.reduce(Object.getOwnPropertyNames(row), function (result, value, key) {
      if (_.startsWith(value, 'cabinCode')) {
        return result.concat(row[value]);
      }
      return result;
    }, []);
    return _.every(cabinCodes, isEmpty);
  }
  function isEmpty(str) {
    return !str || 0 === str.length;
  }
  function isPropertyDefined(gridData, type, configType) {
    var property = advancedHepGridService.getConfigProperty(type, configType);
    if (property) {
      for (var i = 0; i < gridData.length; i++) {
        if (_.isNil(gridData[i][property]) || gridData[i][property].length === 0) {
          toastr.error(type + ' property(s) is missing. Please provide at least one entry for property');
          return false;
        }
      }
    }
    return true;
  }
  function hasOverlappingOrMissingInvervalsAmongRows(editedRows, type, gridData) {
    if (type === 'DA_FareFloorCeiling') {
      var groups = _.groupBy(gridData, function (row) {
        return advancedHepCommonValidationService.constructKey(row, AdvancedHepGridConstants.DA_FARE_FLOOR_CEILING_KEY_VALUES);
      });
      for (var groupKey in groups) {
        if (_.size(groups) > 1 && areFareFloorCeilingRangesOverlappedNotEqual(groups[groupKey], groupKey)) {
          return true;
        }
      }
      return false;
    }
    if (type === 'DA_RIAWeights') {
      //group by POS-Orig-Dest-Cabin
      var posOrigDestCabinGroups = _.groupBy(gridData, function (row) {
        return advancedHepCommonValidationService.constructKey(row, AdvancedHepGridConstants.RIA_NON_RANGE_KEY_VALUES);
      });

      //check that none of AP ranges overlap inside each POS-Orig-Dest-Cabin group
      for (var key in posOrigDestCabinGroups) {
        if (areApRangesOverlappedNotEqual(posOrigDestCabinGroups[key], key)) {
          return true;
        }
      }

      //group by POS-Orig-Dest-Cabin-APFrom-APTo
      var posOrigDestCabinApRangeGroups = _.chain(gridData).filter(function (row) {
        return row.tripType === 'Round Trip';
      }).groupBy(function (row) {
        return advancedHepCommonValidationService.constructKey(row, AdvancedHepGridConstants.RIA_LOS_RANGE_KEY_VALUES);
      }).value();

      //check that all LOS ranges covered inside each POS-Orig-Dest-Cabin-APFrom-APTo group
      //check that none of LOS ranges overlap inside each POS-Orig-Dest-Cabin-APFrom-APTo group
      for (var keyAp in posOrigDestCabinApRangeGroups) {
        if (areLOSRangesOverlapping(posOrigDestCabinApRangeGroups[keyAp], keyAp) || hasMissingLOSRange(posOrigDestCabinApRangeGroups[keyAp], keyAp)) {
          return true;
        }
      }
    }
    return false;
  }
  function areIntervalsOverlapping(editedRows, type, gridData) {
    if (AdvancedHepGridConstants.OVERLAP_TYPES_BETWEEN_ROWS.indexOf(type) !== -1) {
      return hasOverlappingOrMissingInvervalsAmongRows(editedRows, type, gridData);
    }
    if (AdvancedHepGridConstants.OVERLAP_TYPES.indexOf(type) === -1) {
      return false;
    }
    var ranges = advancedHepCommonValidationService.getRangeTypes(type);
    var result = false;
    _.forEach(editedRows, function (row) {
      _.forOwn(row, function (value) {
        if (_.isArray(value)) {
          if (type === 'FOAdvancePurchaseGrouping') {
            if (advancedHepCommonValidationService.isRangesAreOverlappingForAP(gridData, ranges)) {
              result = true;
            }
          } else {
            if (advancedHepCommonValidationService.isRangesAreOverlapping(value, ranges)) {
              result = true;
            }
          }
        }
      });
    });
    return result;
  }
  function areLOSRangesOverlapping(gridData, key) {
    if (advancedHepCommonValidationService.isRangesAreOverlapping(gridData, AdvancedHepGridConstants.RIA_LOS_FULL_RANGE)) {
      toastr.error('Overlapping LOS ranges identified for ' + key);
      return true;
    }
    return false;
  }
  function areFareFloorCeilingRangesOverlappedNotEqual(gridData, key) {
    if (advancedHepCommonValidationService.isRangesAreOverlapping(gridData, AdvancedHepGridConstants.DA_FARE_FLOOR_CEILING_KEY_RANGES, true)) {
      toastr.error('Overlapping Ranges identified for ' + key);
      return true;
    }
    return false;
  }
  function areApRangesOverlappedNotEqual(gridData, key) {
    if (advancedHepCommonValidationService.isRangesAreOverlapping(gridData, AdvancedHepGridConstants.RIA_AP_RANGES, true)) {
      toastr.error('Overlapping AP Ranges identified for ' + key);
      return true;
    }
    return false;
  }
  function getMinLosFrom(gridData, ranges) {
    return _.chain(gridData).map(function (row) {
      return _.toInteger(row[ranges[0]]);
    }).min().value();
  }
  function getMaxLosTo(gridData, ranges) {
    return _.chain(gridData).map(function (row) {
      return _.toInteger(row[ranges[1]]);
    }).max().value();
  }
  function checkForInvalidUserOverrideRows(rows) {
    var messages = new Set();
    rows.forEach(function (row) {
      if (_.isNil(row.cardinalityThreshold) && !_.isEmpty(row.cardinalityThresholdPercentageIndicator)) {
        messages.add('Cardinality Threshold with percentage indicator should be non-empty.');
      }
      if (!_.isNil(row.cardinalityThreshold) && _.isEmpty(row.cardinalityThresholdPercentageIndicator)) {
        messages.add('Cardinality % Indicator with Cardinality Threshold should be non-empty.');
      }
    });
    if (messages.size > 0) {
      messages.forEach(function (message) {
        return toastr.error(message);
      });
      return false;
    }
    return true;
  }
  function isFieldEmpty(eachRow, row, field) {
    return _.isNil(eachRow[field]) && _.isNil(row[field]) || !_.isNil(eachRow[field]) && _.isEmpty(eachRow[field].toString()) && _.isNil(row[field]) || !_.isNil(row[field]) && _.isEmpty(row[field].toString()) && _.isNil(eachRow[field]);
  }
  function isSameFieldValue(eachRow, row, field) {
    return !_.isNil(eachRow[field]) && !_.isNil(row[field]) && eachRow[field].valueOf().toString() === row[field].valueOf().toString();
  }
  function isDifferentTacticalUserOverrideProperty(eachRow, row, field, fieldName) {
    if (isFieldEmpty(eachRow, row, field)) {
      return false;
    }
    if (isSameFieldValue(eachRow, row, field)) {
      return false;
    }
    toastr.error(fieldName + ' should be same for Tactical User Adjustment at level  ' + row.hepKey);
    return true;
  }
  function missingRangeInGroupExists(gridData, ranges) {
    if (getMinLosFrom(gridData, ranges) !== 0 || getMaxLosTo(gridData, ranges) !== 330) {
      return true;
    }
    var inputRanges = _.chain(gridData).sortBy(ranges[0]).map(function (row) {
      return _.values(_.pick(row, ranges));
    }).value();
    for (var i = 0, k = i + 1; i < inputRanges.length; i++) {
      if (inputRanges[k] && inputRanges[k][0] - inputRanges[i][1] !== 1) {
        return true;
      }
      k++;
    }
    return false;
  }
  function hasMissingLOSRange(posOrigDestCabinAPRangeGroup, key) {
    var ranges = AdvancedHepGridConstants.RIA_LOS_FULL_RANGE;
    if (missingRangeInGroupExists(posOrigDestCabinAPRangeGroup, ranges)) {
      toastr.error('Missing Length Of Stay range for ' + key);
      return true;
    }
    return false;
  }
  function isValidFareBrandAndFareType(editedRows, type) {
    var isValid = true;
    var fareBrands = configurationService.getFoFareBrandsForHostCarrier();
    var fareTypes = _.values(FARE_TYPES);
    if (type === 'FOTacticalFBCPatternConfig') {
      _.forEach(editedRows, function (row) {
        if (row.propertyName === 'fareBrand') {
          if (!_.includes(fareBrands, row.propValue)) {
            toastr.error('Fare brand ' + row.propValue + ' must be defined.');
            isValid = false;
          }
        } else if (row.propertyName === 'fareType') {
          if (!_.includes(fareTypes, row.propValue)) {
            toastr.error('Fare Type must be either OW or RT or OWNC');
            isValid = false;
          }
        }
      });
    }
    return isValid;
  }
  function isFareBrandIndexDefinedForHostCarrier(editedRows, type) {
    var isDefined = true;
    if (type === 'FOFareBrandDefinitionConfig') {
      var editedRowsWithHostCarrier = _.filter(editedRows, {
        'carrier': configurationService.getHostCarrier()
      });
      _.forEach(editedRowsWithHostCarrier, function (row) {
        _.forEach(row.fareBrands, function (fareBrand) {
          if (fareBrand.fareBrandIndex === null || fareBrand.fareBrandIndex === undefined) {
            toastr.error('Fare Brand Index must be defined for host carrier.');
            isDefined = false;
          }
        });
      });
    }
    return isDefined;
  }
  function areCustomValidationFulfilled(editedRows, type) {
    var valid = true;
    if (type === 'DA_BookingVelocityPPSAdjustment') {
      _.forEach(editedRows, function (row) {
        if (!valid) {
          return;
        }
        var ppsDataPresent = _.some(AdvancedHepGridConstants.PPS_FIELDS, function (ppsField) {
          return !_.isNil(row[ppsField]);
        });
        var qsiDataPresent = _.some(AdvancedHepGridConstants.QSI_FIELDS, function (qsiField) {
          return !_.isNil(row[qsiField]);
        });
        valid = ppsDataPresent || qsiDataPresent;
        if (ppsDataPresent) {
          valid = _.every(AdvancedHepGridConstants.PPS_FIELDS, function (ppsField) {
            return !_.isNil(row[ppsField]);
          });
        }
        if (valid && qsiDataPresent) {
          valid = _.every(AdvancedHepGridConstants.QSI_FIELDS, function (qsiField) {
            return !_.isNil(row[qsiField]);
          });
        }
      });
    }
    if (type === 'DA_FareBrandDefinition') {
      valid = _.every(editedRows, function (editedRow) {
        return !_.isEmpty(editedRow.fareBrandDefinitionParams);
      });
    }
    if (type === 'FP_MarketConfig') {
      if (featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_ML_MODEL')) {
        _.forEach(editedRows, function (row) {
          if (!valid) {
            return;
          }
          if (row['marketConfigParams_isMlModelEnabled'] === 'Yes' && _.isEmpty(row['marketConfigParams_mlParams'])) {
            valid = false;
          }
        });
      }
    }
    if (type === 'DA_FareBrandNormalization') {
      valid = _.every(editedRows, function (editedRow) {
        return !_.isEmpty(editedRow.fareBrandNormalizationParams);
      });
    }
    if (type === 'DA_FareBrandAssignment') {
      valid = _.every(editedRows, function (editedRow) {
        return !_.isEmpty(editedRow.fareBrandAssignmentParams);
      });
    }
    if (type === 'FORbdAssignment') {
      valid = _.every(editedRows, function (editedRow) {
        if (['ENTRY LEVEL RBD', 'RBD TO RBD', 'ORDINAL', 'FBC MAPPING'].includes(editedRow.rbdMethod) && !['LINEAR', 'EXPONENTIAL'].includes(editedRow.ladderMethod) || ['UPPER BOUND', 'VALUE BASED'].includes(editedRow.rbdMethod) && !['MIN', 'MID', 'MAX', 'NONE'].includes(editedRow.ladderMethod)) {
          toastr.error('Invalid ladder method selected based on the rbd method');
          return false;
        }
        var rbdRows = editedRow['rbdAssignmentCompFareClassList'];
        _.forEach(rbdRows, function (rbdRow) {
          rbdRow.origin = editedRow.origin;
          rbdRow.destination = editedRow.destination;
          rbdRow.category = editedRow.category;
          rbdRow.cabin = editedRow.foCabin;
          rbdRow.rbdMethod = editedRow.rbdMethod;
        });
        return advancedHepModalGridValidationService.validateRbdAssignment(rbdRows);
      });
    }
    return valid;
  }
  function areMarketLevelAttributesValid(editedRows, type, level) {
    var valid = true;
    if (level.includes('marketGroup') && (type === 'FOFareBasisCodePattern' || type === 'FORbdAssignment' || type === 'FORuleMappingAP' || type === 'FORuleMappingDOW' || type === 'FOApplicableDateMapping')) {
      _.forEach(editedRows, function (row) {
        if ((!row.marketGroup || row.marketGroup === '-') && (!row.marketType || row.marketType === '-') && (!row.marketAnalyst || row.marketAnalyst === '-') && (!row.marketCategory || row.marketCategory === '-')) {
          toastr.error('One of the marketGroup, marketType, marketAnalyst, marketCategory should be populated other than empty/hyphen.');
          valid = false;
        }
      });
    }
    return valid;
  }
  function customDefaultValidationErrorMessage(selected) {
    if (!selected) {
      return null;
    }
    switch (selected.type) {
      case 'FP_MarketConfig':
        return 'Mandatory Columns data not filled in. Please ensure you have entered all columns, unhide the columns using \'Customize Columns\' if any are hidden';
      default:
        return null;
    }
  }
  function validate(editedRows, gridData, type, configType, level) {
    return isKeyUniq(editedRows, gridData, type, configType) && isPropertyDefined(gridData, type, configType) && !areIntervalsOverlapping(editedRows, type, gridData) && isValidFareBrandAndFareType(editedRows, type) && isFareBrandIndexDefinedForHostCarrier(editedRows, type) && areCustomValidationFulfilled(editedRows, type) && areMarketLevelAttributesValid(editedRows, type, level);
  }
  return {
    validate: validate,
    areColumnsValidationsFulfilled: areColumnsValidationsFulfilled,
    areReadingTimeIntervalsOverlapping: areIntervalsOverlapping,
    isCustomValidationType: isCustomValidationType,
    customDefaultValidationErrorMessage: customDefaultValidationErrorMessage
  };
};
AdvancedHepGridValidationService.$inject = ['AdvancedHepGridService', 'AdvancedHepPayloadService', 'GridColumnValidationService', 'ConfigurationService', 'AdvancedHepGridConstants', 'FeatureToggleService', 'AdvancedHepCommonValidationService', 'AdvancedHepModalGridValidationService'];
module.exports = AdvancedHepGridValidationService;